import { FadeUp, SectionLabel } from "@/components/Reveal";
import { ShieldCheck, Scale, Lock, FileCheck } from "lucide-react";

const PRINCIPLES = [
  {
    icon: Scale,
    title: "Governed Fees",
    body: "Fees follow The Advocates (Remuneration) Order under the Advocates Act — reasonable, lawful, and flexible to each client's circumstances.",
  },
  {
    icon: FileCheck,
    title: "Retainer Arrangements",
    body: "Corporate clients may opt for retainer services, assuring continued and prompt attention to their legal needs.",
  },
  {
    icon: Lock,
    title: "Confidentiality",
    body: "Client information is held inviolate under The Advocates Practice Rules — with full accountability over client funds.",
  },
];

export default function FeesEthics() {
  return (
    <section
      id="fees"
      data-testid="fees-ethics-section"
      className="relative py-28 lg:py-40 bg-navy-900/40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-5 gap-16 items-start">
          <div className="lg:col-span-3">
            <FadeUp>
              <SectionLabel>Fees &amp; Professional Ethics</SectionLabel>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
                Counsel With <span className="text-gold">Conscience</span>
              </h2>
            </FadeUp>

            <div className="mt-12 space-y-4">
              {PRINCIPLES.map((p, i) => (
                <FadeUp key={p.title} delay={i * 0.12}>
                  <div
                    className="flex gap-5 rounded-3xl border border-gold/15 bg-navy-700/50 p-7 hover:border-gold/40 transition-colors duration-500"
                    data-testid={`ethics-card-${i}`}
                  >
                    <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-gold/25 text-gold">
                      <p.icon size={20} />
                    </span>
                    <div>
                      <h3 className="font-display text-lg">{p.title}</h3>
                      <p className="mt-2 text-sm text-ink-dim leading-relaxed">{p.body}</p>
                    </div>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <FadeUp delay={0.2}>
              <div
                className="relative rounded-3xl border border-gold/25 bg-navy-950/80 p-10 text-center shadow-[0_0_60px_rgba(154,136,15,0.10)]"
                data-testid="indemnity-card"
              >
                <ShieldCheck className="mx-auto text-gold" size={32} />
                <div className="font-mono text-xs uppercase tracking-[0.3em] text-ink-muted mt-6">
                  Professional Indemnity Cover
                </div>
                <div className="font-display text-4xl sm:text-5xl text-gold mt-4">
                  KShs 10M
                </div>
                <div className="gold-hairline my-8" />
                <p className="text-sm text-ink-dim leading-relaxed">
                  Every brief is backed by a KShs 10,000,000 professional
                  indemnity cover. A copy is supplied on demand — and larger
                  covers can be arranged where a client's matter requires it.
                </p>
              </div>
            </FadeUp>

            <FadeUp delay={0.35} className="mt-6">
              <div className="relative rounded-3xl overflow-hidden border border-gold/15 h-56">
                <img
                  src="https://images.pexels.com/photos/6077091/pexels-photo-6077091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                  alt="Law library volumes"
                  className="w-full h-full object-cover opacity-70"
                  data-testid="ethics-library-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950 to-transparent" />
                <p className="absolute bottom-5 left-6 font-editorial italic text-lg text-ink">
                  "Work ethics are paramount."
                </p>
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
